__webpack_require__.p = "https://affiliate-tp.devlovin.com/scripts/";